import { Injectable } from '@angular/core';
import { IRoute, MenuService, RouterItemPg } from 'viggo-sistemas-core-web';

/**
 * Ordena 2 itens de menu em ordem alfabética
 */
const ordemAlfabetica = (a: RouterItemPg, b: RouterItemPg) =>
  a.label > b.label ? 1 : -1;

@Injectable()
export class CustomMenuService extends MenuService {
  // defina suas rotas aqui;
  protected createDynamicsMenuPg(routes: IRoute[]): RouterItemPg[] {
    /**
     * é requirido que você chame a classe super para definir as rotas padrões
     */
    let defaultMenu = super.createDynamicsMenuPg(routes);

    const cadastrosMenu = this.createCadastrosMenu(routes);
    if (cadastrosMenu) defaultMenu = defaultMenu.concat(cadastrosMenu);

    const suprimentoMenu = this.createSuprimentoMenu(routes);
    if (suprimentoMenu) defaultMenu = defaultMenu.concat(suprimentoMenu);

    const gradeProdutoMenu = this.createMenuGradeProdutos(routes);
    if (gradeProdutoMenu) defaultMenu = defaultMenu.concat(gradeProdutoMenu);

    const vendasMenu = this.createMenuVendas(routes);
    if (vendasMenu) defaultMenu = defaultMenu.concat(vendasMenu);

    const financeiroMenu = this.createMenuFinanceiro(routes);
    if (financeiroMenu) defaultMenu = defaultMenu.concat(financeiroMenu);

    const configMenu = this.createConfigMenu(routes);
    if (configMenu && this.tokenService.getUser().name !== 'sysadmin')
      defaultMenu = defaultMenu.concat(configMenu);

    const localizacaoMenu = this.createLocalizacaoMenu(routes);
    if (localizacaoMenu) defaultMenu = defaultMenu.concat(localizacaoMenu);

    const ncmIbptMenu = this.createMenuNcmIbpt(routes);
    if (ncmIbptMenu) defaultMenu = defaultMenu.concat(ncmIbptMenu);

    const subRotinaMenu = this.createMenuSubRotina(routes);
    if (subRotinaMenu) defaultMenu = defaultMenu.concat(subRotinaMenu);

    const custosDominioMenu = this.createMenuCustosPorDominio(routes);
    if (custosDominioMenu) defaultMenu = defaultMenu.concat(custosDominioMenu);

    const erroIntegrationMenu = this.createMenuErroIntegration(routes);
    if (erroIntegrationMenu)
      defaultMenu = defaultMenu.concat(erroIntegrationMenu);

    const externalMenu = this.createErroIntegrationExternal(routes);
    if (externalMenu) defaultMenu = defaultMenu.concat(externalMenu);

    const cardapioMenu = this.criarMenuCardapio(routes);
    if (cardapioMenu) defaultMenu = defaultMenu.concat(cardapioMenu);

    return defaultMenu;
  }
  //MENU SYSADMIN
  /**
   * Cria o menu lateral de Localização
   * @param routes Rotas pemitidas ao usuário
   */
  createLocalizacaoMenu(routes: IRoute[]) {
    let menu: RouterItemPg;
    let submenu = [] as RouterItemPg[];

    submenu = this.filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Mesoregiões',
          isSubMenu: false,
          icon: 'pi pi-fw pi-map',
          routerLink: ['/mesorregioes'],
          idElement: 'menu-mesoregiao'
        },
        matchBackendRoutes: [{ url: '/mesorregioes/<id>', method: 'PUT' }]
      },
      {
        menuItem: {
          label: 'Microregiões',
          isSubMenu: false,
          icon: 'pi pi-fw pi-map',
          routerLink: ['/microrregioes'],
          idElement: 'menu-microregiao'
        },
        matchBackendRoutes: [
          {
            url: '/microrregioes/<id>',
            method: 'PUT'
          }
        ]
      },
      {
        menuItem: {
          label: 'Municípios',
          isSubMenu: false,
          icon: 'pi pi-fw pi-map',
          routerLink: ['/municipios'],
          idElement: 'menu-municipio'
        },
        matchBackendRoutes: [
          {
            url: '/municipios/<id>',
            method: 'PUT'
          }
        ]
      },
      {
        menuItem: {
          label: 'Regiões',
          isSubMenu: false,
          icon: 'pi pi-fw pi-map',
          routerLink: ['/regioes'],
          idElement: 'menu-regiao'
        },
        matchBackendRoutes: [
          {
            url: '/regioes/<id>',
            method: 'PUT'
          }
        ]
      },
      {
        menuItem: {
          label: 'Países',
          isSubMenu: false,
          icon: 'pi pi-fw pi-map',
          routerLink: ['/paises'],
          idElement: 'menu-pais'
        },
        matchBackendRoutes: [
          {
            url: '/paises/<id>',
            method: 'PUT'
          }
        ]
      },
      {
        menuItem: {
          label: 'UFs',
          isSubMenu: false,
          icon: 'pi pi-fw pi-map',
          routerLink: ['/ufs'],
          idElement: 'menu-uf'
        },
        matchBackendRoutes: [{ url: '/ufs/<id>', method: 'PUT' }]
      }
    ]);

    submenu.sort(ordemAlfabetica);

    if (submenu.length > 0)
      menu = {
        label: 'Localização',
        icon: 'pi pi-fw pi-map',
        routerLink: null,
        isSubMenu: false,
        idElement: 'menu-localizacao',
        items: submenu
      };
    return menu;
  }

  //MENU VEX
  /**
   * Gera o menu de cadastros do sistema - contém SUBMENU
   * @param routes
   * @returns
   */
  createCadastrosMenu(routes: IRoute[]) {
    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];

    submenu = this.filterGrantSubMenuItens(routes, [
      {
        menuItem: {
          label: 'Produtos',
          isSubMenu: false,
          routerLink: ['/produtos'],
          icon: 'pi pi-fw pi-box',
          idElement: 'menu-produto',
          precedence: 1
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/produtos'
          }
        ]
      },
      {
        menuItem: {
          icon: 'mdi mdi-account',
          label: 'Participantes',
          routerLink: null,
          isSubMenu: true,
          idElement: 'menu-participantes',
          items: [
            {
              icon: 'mdi mdi-account',
              isSubMenu: false,
              label: 'Clientes',
              routerLink: ['/cliente'],
              idElement: 'menu-parceiro-cliente',
              backend_config: [
                {
                  url: '/clientes',
                  method: 'GET'
                }
              ],
              precedence: 1
            },
            {
              label: 'Pré clientes',
              isSubMenu: false,
              icon: 'mdi mdi-contacts-outline',
              routerLink: ['/precliente'],
              idElement: 'menu-parceiro-precliente',
              backend_config: [
                {
                  url: '/pre_clientes',
                  method: 'GET'
                }
              ],
              precedence: 2
            },
            {
              label: 'Fornecedores',
              isSubMenu: false,
              icon: 'mdi mdi-domain',
              routerLink: ['/fornecedores'],
              idElement: 'menu-parceiro-fornecedor',
              backend_config: [
                {
                  url: '/fornecedores',
                  method: 'POST'
                }
              ],
              precedence: 3
            },
            {
              label: 'Fabricantes',
              isSubMenu: false,
              icon: 'mdi mdi-office-building',
              idElement: 'menu-parceiro-fabricante',
              routerLink: ['/fabricantes'],
              backend_config: [
                {
                  url: '/fabricantes',
                  method: 'GET'
                }
              ],
              precedence: 4
            },
            {
              label: 'Supervisor',
              isSubMenu: false,
              routerLink: ['/supervisor'],
              icon: 'mdi mdi-account-supervisor-circle-outline',
              idElement: 'menu-parceiro-supervisor',
              backend_config: [
                {
                  url: '/supervisores',
                  method: 'GET'
                }
              ],
              precedence: 5
            },
            {
              label: 'Vendedor',
              isSubMenu: false,
              routerLink: ['/vendedor'],
              icon: 'mdi mdi-account-multiple-outline',
              idElement: 'menu-parceiro-vendedor',
              backend_config: [
                {
                  url: '/vendedores',
                  method: 'GET'
                }
              ],
              precedence: 6
            }
          ]
        },
        matchBackendRoutes: [
          {
            url: '/clientes',
            method: 'GET'
          },
          {
            url: '/fornecedores',
            method: 'POST'
          },
          {
            url: '/vendedores',
            method: 'GET'
          },
          {
            url: '/fabricantes',
            method: 'GET'
          },
          {
            url: '/supervisores',
            method: 'GET'
          },
          {
            url: '/pre_clientes',
            method: 'GET'
          }
        ]
      },
      {
        menuItem: {
          label: 'Tabela de preços',
          isSubMenu: false,
          routerLink: ['/tabela-preco'],
          icon: 'mdi mdi-file-table-box-multiple-outline',
          idElement: 'menu-tabelas',
          precedence: 6
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/tabela_precos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Catálogo de produtos',
          isSubMenu: false,
          routerLink: ['/catalogo-produto'],
          icon: 'mdi mdi-notebook',
          idElement: 'menu-catalogo'
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/catalogos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Equipe de vendas',
          isSubMenu: false,
          routerLink: ['/equipe-venda'],
          idElement: 'menu-equipe',
          icon: 'mdi mdi-account-group-outline',
          precedence: 6
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/equipe_vendas'
          }
        ]
      },
      {
        menuItem: {
          label: 'Tags',
          isSubMenu: false,
          routerLink: ['/tags'],
          icon: 'pi pi-fw pi-tags',
          idElement: 'menu-tags'
        },
        matchBackendRoutes: [
          {
            url: '/tags',
            method: 'POST'
          }
        ]
      },
      {
        menuItem: {
          label: 'Instituições financeiras',
          isSubMenu: false,
          routerLink: ['/instituicoes_financeiras'],
          icon: 'pi pi-fw pi-building',
          idElement: 'menu-instituicao'
        },
        matchBackendRoutes: [
          {
            url: '/instituicao_pagamentos',
            method: 'GET'
          }
        ]
      }
    ]);

    submenu.sort(ordemAlfabetica);

    if (submenu.length > 0)
      menu = {
        label: 'Cadastros',
        icon: 'mdi mdi-plus-box-multiple-outline',
        isSubMenu: true,
        routerLink: null,
        items: submenu,
        idElement: 'menu-cadastros'
      };

    return menu;
  }

  /**
   * Gera o menu do módulo de suprimentos
   * @param routes Rotas permitidas ao usuário
   */
  createSuprimentoMenu(routes: IRoute[]): RouterItemPg | RouterItemPg[] {
    let menu: RouterItemPg | RouterItemPg[];

    let submenu: RouterItemPg[] = this.filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Entrada',
          isSubMenu: false,
          routerLink: ['/entrada'],
          icon: 'mdi mdi-archive-arrow-down-outline',
          idElement: 'menu-entrada',
          precedence: 4
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/rees'
          }
        ]
      },
      {
        menuItem: {
          label: 'Saida',
          isSubMenu: false,
          icon: 'mdi mdi-archive-arrow-up-outline',
          idElement: 'menu-saida',
          routerLink: ['/saida'],
          precedence: 5
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/rses'
          }
        ]
      },
      {
        menuItem: {
          label: 'Entrada fiscal',
          isSubMenu: false,
          routerLink: ['/entrada_fiscal'],
          idElement: 'menu-entrada-fiscal',
          icon: 'mdi mdi-xml'
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/produto_entrada_fiscais'
          }
        ]
      }
    ]);

    submenu.sort(ordemAlfabetica);

    if (submenu.length > 0)
      menu = {
        label: 'Suprimentos',
        isSubMenu: false,
        icon: 'mdi mdi-archive-plus-outline',
        idElement: 'menu-principal-produto',
        routerLink: null,
        items: submenu
      };
    return menu;
  }

  /**
   * Menu que exibe os produtos variação
   * @param routes rotas para verificar permissao
   */
  protected createMenuGradeProdutos(routes: IRoute[]) {
    const menu: RouterItemPg[] = this.filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Grade de produtos',
          isSubMenu: false,
          routerLink: ['/produtos/variacoes'],
          icon: 'mdi mdi-sitemap',
          idElement: 'menu-produto-grade'
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/produto_variacoes'
          }
        ]
      }
    ]);
    return menu;
  }

  /**
   * Gera o menu do módulo de vendas
   * @param routes Rotas permitidas ao usuário
   */
  protected createMenuVendas(routes: IRoute[]): RouterItemPg {
    let menu: RouterItemPg;

    let submenu: RouterItemPg[] = this.filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Pedido',
          isSubMenu: false,
          routerLink: ['/pedidos'],
          idElement: 'menu-pedido',
          icon: 'mdi mdi-receipt-text-outline',
          precedence: 1
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/pedidos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Pedidos integração',
          isSubMenu: false,
          routerLink: ['/pedidos-integracao'],
          idElement: 'menu-pedido-integracao',
          icon: 'mdi mdi-receipt-text-check-outline',
          precedence: 2
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/pedido_integracaos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Pré pedidos',
          isSubMenu: false,
          routerLink: ['/pre-pedidos'],
          idElement: 'menu-prepedido',
          icon: 'mdi mdi-receipt-text-clock-outline',
          precedence: 3
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/pre_pedidos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Caixa',
          isSubMenu: false,
          routerLink: ['/pdv'],
          precedence: 4,
          icon: 'pi pi-fw pi-desktop',
          idElement: 'menu-nfce'
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/pedido_nfces'
          }
        ]
      },
      {
        menuItem: {
          label: 'NF-e',
          isSubMenu: false,
          precedence: 5,
          routerLink: ['/nfes'],
          icon: 'pi pi-fw pi-calculator',
          idElement: 'menu-nfe'
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/nfes'
          }
        ]
      },
      {
        menuItem: {
          label: 'NFC-e',
          isSubMenu: false,
          routerLink: ['/nfces'],
          icon: 'pi pi-fw pi-calculator',
          precedence: 6,
          idElement: 'menu-nfce'
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/nfces'
          }
        ]
      },
      {
        menuItem: {
          label: 'Por venda',
          isSubMenu: false,
          routerLink: ['/relatorio/vendas'],
          icon: 'pi pi-fw pi-print',
          precedence: 7,
          idElement: 'menu-report-vendas'
        },
        matchBackendRoutes: [
          {
            url: '/pedidos',
            method: 'GET'
          }
        ]
      },
      {
        menuItem: {
          label: 'Por NFCe',
          isSubMenu: false,
          routerLink: ['/relatorio/nfces'],
          icon: 'pi pi-fw pi-print',
          precedence: 8,
          idElement: 'menu-report-nfces'
        },
        matchBackendRoutes: [
          {
            url: '/nfces',
            method: 'GET'
          }
        ]
      }
    ]);
    if (submenu.length) {
      submenu = this.sortItensPg(submenu);

      menu = {
        label: 'Vendas',
        idElement: 'menu-vendas',
        isSubMenu: false,
        icon: 'mdi mdi-cart-outline',
        routerLink: null,
        items: submenu
      };
    }
    return menu;
  }

  /**
   * Cria o menu lateral de Configurações do sistema
   * @param routes Rotas pemitidas ao usuário
   */
  protected createConfigMenu(routes: IRoute[]) {
    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];

    submenu = this.filterGrantSubMenuItens(routes, [
      {
        menuItem: {
          label: 'Fiscal',
          isSubMenu: true,
          routerLink: null,
          icon: 'pi pi-fw pi-calculator',
          items: [
            {
              label: 'Certificado digital',
              isSubMenu: false,
              routerLink: ['/certificado_digital'],
              icon: 'pi pi-fw pi-file',
              idElement: 'menu-certificado',
              backend_config: [
                {
                  url: '/certificado_digitals',
                  method: 'POST'
                }
              ],
              precedence: 1
            },
            {
              label: 'Forma pagto sefaz',
              isSubMenu: false,
              routerLink: ['/forma_pagto_sefaz'],
              icon: 'pi pi-fw pi-credit-card',
              idElement: 'menu-sefaz',
              backend_config: [
                {
                  url: '/formas_pagamento_sefaz',
                  method: 'POST'
                }
              ],
              precedence: 2
            },
            {
              label: 'UFICMS',
              isSubMenu: false,
              routerLink: ['/uficms'],
              icon: 'pi pi-fw pi-calculator',
              idElement: 'menu-uficms',
              backend_config: [
                {
                  url: '/uficmss',
                  method: 'POST'
                }
              ],
              precedence: 3
            },
            {
              label: 'Regra fiscal',
              isSubMenu: false,
              routerLink: ['/regra_fiscal'],
              icon: 'pi pi-fw pi-briefcase',
              idElement: 'menu-regra-fiscal',
              backend_config: [
                {
                  url: '/regra_fiscals',
                  method: 'POST'
                }
              ],
              precedence: 4
            },
            {
              label: 'Natureza de operação',
              isSubMenu: false,
              routerLink: ['/natureza_operacao'],
              icon: 'pi pi-fw pi-key',
              idElement: 'menu-natureza-operacao',
              backend_config: [
                {
                  url: '/natureza_operacaos',
                  method: 'POST'
                }
              ],
              precedence: 5
            },
            {
              label: 'Série fiscal',
              isSubMenu: false,
              routerLink: ['/serie_fiscal'],
              icon: 'mdi mdi-numeric',
              idElement: 'menu-serie-fiscal',
              backend_config: [
                {
                  url: '/serie_fiscals',
                  method: 'POST'
                }
              ],
              precedence: 6
            },
            {
              label: 'Tipo operação',
              isSubMenu: false,
              routerLink: ['/tipo_operacao'],
              icon: 'pi pi-fw pi-briefcase',
              idElement: 'menu-tipo-operacao',
              backend_config: [
                {
                  url: '/tipo_operacaos',
                  method: 'POST'
                }
              ],
              precedence: 7
            },
            {
              label: 'Portarias',
              isSubMenu: false,
              routerLink: ['/portaria'],
              icon: 'pi pi-fw pi-wrench',
              idElement: 'menu-portaria',
              backend_config: [
                {
                  url: '/portarias',
                  method: 'POST'
                }
              ],
              precedence: 8
            }
          ],
          idElement: 'menu-config-fiscal'
        },
        matchBackendRoutes: [
          {
            url: '/certificado_digitals',
            method: 'POST'
          },
          {
            url: '/portarias',
            method: 'POST'
          },
          {
            url: '/uficmss',
            method: 'POST'
          },
          {
            url: '/formas_pagamento_sefaz',
            method: 'POST'
          },
          {
            url: '/regra_fiscals',
            method: 'POST'
          },
          {
            url: '/serie_fiscals',
            method: 'POST'
          },
          {
            url: '/natureza_operacaos',
            method: 'POST'
          },
          {
            url: '/tipo_operacaos',
            method: 'POST'
          }
        ]
      },
      {
        menuItem: {
          label: 'Financeiro',
          isSubMenu: true,
          routerLink: null,
          icon: 'mdi mdi-currency-brl',
          items: [
            {
              label: 'Portadores',
              isSubMenu: false,
              routerLink: ['/portadores'],
              icon: 'pi pi-fw pi-money-bill',
              idElement: 'menu-portador',
              backend_config: [
                {
                  url: '/portadores/<id>/ajuste_saldo',
                  method: 'PUT'
                }
              ],
              precedence: 1
            },
            {
              label: 'Natureza financeiras',
              isSubMenu: false,
              routerLink: ['/natureza_financeiras'],
              icon: 'pi pi-fw pi-money-bill',
              idElement: 'menu-natureza-financeira',
              backend_config: [
                {
                  url: '/natureza_financeiras',
                  method: 'POST'
                }
              ],
              precedence: 2
            },
            {
              label: 'Centro de resultado',
              isSubMenu: false,
              routerLink: ['/centro_resultados'],
              icon: 'pi pi-fw pi-money-bill',
              idElement: 'menu-centro-resultado',
              backend_config: [
                {
                  url: '/centro_resultados',
                  method: 'POST'
                }
              ],
              precedence: 3
            }
          ],
          idElement: 'menu-config-financeiro'
        },
        matchBackendRoutes: [
          {
            url: '/portadores/<id>/ajuste_saldo',
            method: 'PUT'
          },
          {
            url: '/natureza_financeiras',
            method: 'POST'
          },
          {
            url: '/centro_resultados',
            method: 'POST'
          }
        ]
      },
      {
        menuItem: {
          label: 'Vendas',
          isSubMenu: true,
          routerLink: null,
          icon: 'mdi mdi-cart-outline',
          items: [
            {
              label: 'Terminais',
              isSubMenu: false,
              routerLink: ['/terminais'],
              icon: 'pi pi-fw pi-desktop',
              idElement: 'menu-terminal',
              backend_config: [
                {
                  url: '/terminais',
                  method: 'POST'
                }
              ],
              precedence: 1
            },
            {
              label: 'Formas de Pagamento',
              isSubMenu: false,
              routerLink: ['/formas-pagamento'],
              idElement: 'menu-formaspagto',
              icon: 'mdi mdi-credit-card-outline',
              backend_config: [
                {
                  url: '/forma_pagamentos',
                  method: 'GET'
                }
              ],
              precedence: 2
            },
            {
              label: 'Condição de Pagamento',
              isSubMenu: false,
              routerLink: ['/condicao-pagamento'],
              idElement: 'menu-condpagto',
              icon: 'mdi mdi-cash-multiple',
              backend_config: [
                {
                  url: '/condicao_pagamentos',
                  method: 'GET'
                }
              ],
              precedence: 3
            }
          ],
          idElement: 'menu-config-vendas'
        },
        matchBackendRoutes: [
          {
            url: '/terminais',
            method: 'POST'
          },
          {
            url: '/forma_pagamentos',
            method: 'GET'
          },
          {
            url: '/condicao_pagamentos',
            method: 'GET'
          }
        ]
      },
      {
        menuItem: {
          label: 'Produto',
          isSubMenu: true,
          routerLink: null,
          icon: 'pi pi-fw pi-box',
          items: [
            {
              label: 'Variações pro produto',
              isSubMenu: false,
              routerLink: ['/variacao_produtos'],
              icon: 'mdi mdi-vector-difference-ba',
              idElement: 'menu-variacoes',
              backend_config: [
                {
                  url: '/variacoes',
                  method: 'POST'
                }
              ],
              precedence: 1
            },
            {
              label: 'Grupos',
              isSubMenu: false,
              routerLink: ['/grupos'],
              icon: 'mdi mdi-shape-outline',
              idElement: 'menu-grupo',
              backend_config: [
                {
                  url: '/grupos',
                  method: 'POST'
                }
              ],
              precedence: 1
            },
            {
              label: 'Unidades',
              isSubMenu: false,
              icon: 'mdi mdi-sitemap',
              idElement: 'menu-unidade',
              routerLink: ['/unidades'],
              backend_config: [
                {
                  url: '/unidades',
                  method: 'GET'
                }
              ],
              precedence: 2
            },
            {
              label: 'Encartes de promoção',
              isSubMenu: false,
              icon: 'mdi mdi-store-clock-outline',
              idElement: 'menu-encartes-promocao',
              routerLink: ['/encartes_promocao'],
              backend_config: [
                {
                  url: '/promocao_produtos',
                  method: 'GET'
                }
              ],
              precedence: 2
            }
          ],
          idElement: 'menu-config-produtos'
        },
        matchBackendRoutes: [
          {
            url: '/variacoes',
            method: 'POST'
          },
          {
            url: '/unidades',
            method: 'GET'
          },
          {
            url: '/promocao_produtos',
            method: 'GET'
          }
        ]
      },
      {
        menuItem: {
          label: 'Empresa',
          isSubMenu: true,
          routerLink: null,
          icon: 'pi pi-fw pi-building',
          items: [
            {
              label: 'Dados da empresa',
              icon: 'pi pi-fw pi-building',
              isSubMenu: false,
              routerLink: ['/dados-empresa/editar'],
              idElement: 'menu-dados-empresa',
              backend_config: [
                {
                  url: '/domains/<id>',
                  method: 'PUT'
                }
              ],
              precedence: 1
            },
            {
              label: 'Regras de negócio',
              icon: 'pi pi-fw pi-briefcase',
              isSubMenu: false,
              routerLink: ['/dados-empresa/settings'],
              idElement: 'menu-regras-negocio',
              backend_config: [
                {
                  url: '/domains/<id>/settings',
                  method: 'PUT'
                }
              ],
              precedence: 2
            },
            {
              label: 'Dados fiscais da empresa',
              icon: 'pi pi-fw pi-calculator',
              isSubMenu: false,
              routerLink: ['/dados-fiscais/editar-fiscal'],
              idElement: 'menu-dados-fiscal',
              backend_config: [
                {
                  url: '/domain_orgs',
                  method: 'POST'
                }
              ],
              precedence: 3
            }
          ],
          idElement: 'menu-config-empresa'
        },
        matchBackendRoutes: [
          {
            url: '/domains/<id>',
            method: 'PUT'
          },
          {
            url: '/domains/<id>/settings',
            method: 'PUT'
          },
          {
            url: '/domain_orgs',
            method: 'POST'
          }
        ]
      }
    ]);

    submenu.sort(ordemAlfabetica);

    if (submenu.length > 0)
      menu = {
        label: 'Configurações',
        isSubMenu: true,
        routerLink: null,
        items: submenu,
        icon: 'pi pi-fw pi-cog',
        idElement: 'menu-config'
      };

    return menu;
  }

  /**
   * Menu que exibe os erros das integrações externas
   * @param routes rotas para verificar permissao
   */
  protected createErroIntegrationExternal(routes: IRoute[]) {
    const menu: RouterItemPg[] = this.filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Erros das integrações externas',
          isSubMenu: false,
          routerLink: ['/erro-integracoes-externas'],
          icon: 'pi pi-fw pi-times-circle',
          idElement: 'menu-log-erro'
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/log_erro_integracao_externas'
          }
        ]
      }
    ]);
    return menu;
  }

  /**
   * Menu que exibe os NCMs
   * @param routes rotas para verificar permissao
   */
  protected createMenuNcmIbpt(routes: IRoute[]) {
    const menu: RouterItemPg[] = this.filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'NCM IBPT',
          isSubMenu: false,
          routerLink: ['/ncm_ibpts'],
          icon: 'pi pi-fw pi-file',
          idElement: 'menu-ncm-ibpts'
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/ncmibpts'
          }
        ]
      }
    ]);
    return menu;
  }

  /**
   * Menu que exibe as subrotinas que podem ser processadas
   * @param routes rotas para verificar permissao
   */
  protected createMenuSubRotina(routes: IRoute[]) {
    const menu: RouterItemPg[] = this.filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Sub-rotinas da integração',
          isSubMenu: false,
          routerLink: ['/iniciar_subrotina'],
          icon: 'pi pi-fw pi-code',
          idElement: 'menu-sub-rotina'
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/integracoes/inicia_subrotina'
          }
        ]
      }
    ]);
    return menu;
  }

  /**
   * Cria o menu de erros da integração
   * @param routes rotas do backend para verificação
   */
  protected createMenuErroIntegration(routes: IRoute[]) {
    const menu: RouterItemPg[] = this.filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Erros da integração',
          isSubMenu: false,
          icon: 'pi pi-fw pi-times-circle',
          routerLink: ['/erro-integracao'],
          idElement: 'error-integration'
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/erro_integracaos'
          }
        ]
      }
    ]);
    return menu;
  }

  /**
   * Menu que cria os itens da parte fiscal
   * @param routes rotas para verificar permissao
   */
  protected createMenuFinanceiro(routes: IRoute[]): RouterItemPg {
    let subitem: RouterItemPg = null;

    const menu = this.filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Contas a receber',
          isSubMenu: false,
          routerLink: ['/contas-receber'],
          icon: 'pi pi-fw pi-money-bill',
          idElement: 'menu-contareceber',
          backend_url_route: '/conta_recebers'
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/conta_recebers'
          }
        ]
      },
      {
        menuItem: {
          label: 'Contas a pagar',
          isSubMenu: false,
          routerLink: ['/contas-pagar'],
          icon: 'pi pi-fw pi-money-bill',
          idElement: 'menu-contapagar',
          backend_url_route: '/conta_pagars'
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/conta_pagars'
          }
        ]
      },
      {
        menuItem: {
          label: 'Movimentação financeira',
          isSubMenu: false,
          routerLink: ['/movimentacao_financeira'],
          icon: 'pi pi-fw pi-money-bill',
          idElement: 'menu-movimentacao-financeira',
          backend_url_route: '/movimentacao_financeiras'
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/movimentacao_financeiras'
          }
        ]
      },
      {
        menuItem: {
          label: 'Registros dos Caixas',
          isSubMenu: false,
          routerLink: ['/registros_caixa'],
          icon: 'pi pi-fw pi-money-bill',
          idElement: 'menu-registros-caixa',
          backend_url_route: '/caixas'
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/caixas'
          }
        ]
      },
      {
        menuItem: {
          label: 'Por entradas e saídas',
          isSubMenu: false,
          routerLink: ['/relatorio/entrada_saida'],
          icon: 'pi pi-fw pi-print',
          idElement: 'menu-report-entrada-saida'
        },
        matchBackendRoutes: [
          {
            url: '/movimentacao_financeiras',
            method: 'GET'
          }
        ]
      }
    ]);

    // menu.sort(ordemAlfabetica);

    if (menu.length)
      subitem = {
        label: 'Financeiro',
        isSubMenu: false,
        routerLink: null,
        items: menu,
        icon: 'mdi mdi-currency-brl',
        idElement: 'menu-contareceber'
      };

    return subitem;
  }

  /**
   * Cria o menu do cardápio
   * @param routes rotas vindas do backend
   */
  protected criarMenuCardapio(routes: IRoute[]): RouterItemPg {
    let menuItem: RouterItemPg = null;
    const items = this.filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Cardápio item',
          isSubMenu: false,
          routerLink: ['/cardapio-item'],
          icon: 'pi pi-fw pi-book',
          idElement: 'menu-cardapio'
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/cardapio_item_produtos'
          },
          {
            method: 'POST',
            url: '/cardapio_item_pratos'
          }
        ]
      },
      {
        menuItem: {
          label: 'Porção',
          isSubMenu: false,
          routerLink: ['/porcao'],
          icon: 'pi pi-fw pi-book',
          idElement: 'menu-porcao'
        },
        matchBackendRoutes: [{ url: '/porcoes', method: 'POST' }]
      },
      {
        menuItem: {
          label: 'Tipo de porção',
          isSubMenu: false,
          routerLink: ['/porcao-tipo'],
          icon: 'pi pi-fw pi-book',
          idElement: 'menu-tipoporcao'
        },
        matchBackendRoutes: [{ url: '/porcao_tipos', method: 'POST' }]
      }
    ]);

    if (items.length)
      menuItem = {
        label: 'Cardápio',
        isSubMenu: false,
        items,
        routerLink: null,
        icon: 'pi pi-fw pi-book',
        idElement: 'menu-principal-cardapio'
      };

    return menuItem;
  }

  /**
   * Cria o menu de custos de aplicações por domínio
   * @param routes
   * @returns
   */
  protected createMenuCustosPorDominio(routes: IRoute[]): RouterItemPg{

    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];

    submenu = this.filterGrantSubMenuItens(routes, [
      {
        menuItem: {
          label: 'Tabela de custos por domínio',
          isSubMenu: false,
          routerLink: ['/custos_por_dominio'],
          icon: 'pi pi-fw pi-chart-bar',
          idElement: 'menu-custos-dominio',
          precedence: 1
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/domains/get_usage_info_by_domain'
          }
        ]
      },
      {
        menuItem: {
          icon: 'pi pi-fw pi-cog',
          label: 'Parametrização',
          routerLink: null,
          isSubMenu: true,
          idElement: 'menu-parametrizacao',
          items: [
            {
              icon: 'mdi mdi-numeric',
              isSubMenu: false,
              label: 'Pesos por aplicação',
              routerLink: ['/pesos_aplicacao'],
              idElement: 'menu-pesos-aplicacao',
              backend_config: [
                {
                  url: '/constant_for_calculations',
                  method: 'POST'
                }
              ],
              precedence: 1
            },
            {
              label: 'Custos por aplicação',
              isSubMenu: false,
              icon: 'mdi mdi-cash',
              routerLink: ['/custos_aplicacao'],
              idElement: 'menu-custos-aplicacao',
              backend_config: [
                {
                  url: '/project_costs',
                  method: 'POST'
                }
              ],
              precedence: 2
            }
          ]
        },
        matchBackendRoutes: [
          {
            url: '/constant_for_calculations',
            method: 'POST'
          },
          {
            url: '/project_costs',
            method: 'POST'
          }
        ]
      }
    ]);

    submenu.sort(ordemAlfabetica);

    if (submenu.length > 0)
      menu = {
        label: 'Custos por domínio',
        icon: 'mdi mdi-finance',
        isSubMenu: true,
        routerLink: null,
        items: submenu,
        idElement: 'menu-custos-dominio'
      };

    return menu;
  }
}
